define(['marketplace/components/asset_util'], function(AssetUtil) {

		var validateNumber = function(val) {
			// remove spaces and dashes
			val = val.replace(/-|\s/g,"");

			if (/[^0-9-\s]+/.test(val)) return false;

			var luhnChk = (function (arr) {
				return function (ccNum) {
					var
						len = ccNum.length,
						bit = 1,
						sum = 0,
						val;

						while (len) {
							val = parseInt(ccNum.charAt(--len), 10);
							sum += (bit ^= 1) ? arr[val] : val;
						}

						return sum && sum % 10 === 0;
					};
			}([0, 2, 4, 6, 8, 1, 3, 5, 7, 9]));

			return luhnChk(val);
		};

		var cardImage = function(cardName) {
			var cardUrls = {
				cvc: AssetUtil.getAsset("images/checkout/cards/CVC.svg"),
				amex: AssetUtil.getAsset("images/checkout/cards/Amex.svg"),
				diners: AssetUtil.getAsset("images/checkout/cards/Diners-Club.svg"),
				discover: AssetUtil.getAsset("images/checkout/cards/Discover.svg"),
				jcb: AssetUtil.getAsset("images/checkout/cards/JCB.svg"),
				mastercard: AssetUtil.getAsset("images/checkout/cards/Mastercard.svg"),
				maestro: AssetUtil.getAsset("images/checkout/cards/Maestro.svg"),
				visa: AssetUtil.getAsset("images/checkout/cards/Visa.svg")
			};
			var cardTypeToImg = {
				'visa': cardUrls.visa,
				'mastercard': cardUrls.mastercard,
				'mc': cardUrls.mastercard,
				'american express': cardUrls.amex,
				'american_express': cardUrls.amex,
				'amex': cardUrls.amex,
				'diners club': cardUrls.diners,
				'discover': cardUrls.discover,
				'maestro': cardUrls.maestro,
				'jcb': cardUrls.jcb
			};
			return cardTypeToImg[cardName.toLowerCase()];
		};

		return {
			validateNumber: validateNumber,
			cardImage: cardImage
		};
});
